/**
 * ==================================================================================
 * Service Worker Update: Triggers an alert box that tells the user the current
 * page/cache being served isn't the latest one
 * ==================================================================================
 **/

import { mapActions } from 'vuex'

export default {
  data: function() {
    return {
      serviceWorkerRefreshing: false,
      serviceWorkerRegistration: null,
      serviceWorkerHasUpdate: false
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alert/addAlert'
    }),

    refresh() {
      this.serviceWorkerHasUpdate = false
      if (
        !this.serviceWorkerRegistration ||
        !this.serviceWorkerRegistration.waiting
      )
        return
      this.serviceWorkerRegistration.waiting.postMessage({
        type: 'SKIP_WAITING'
      })
    },

    updateAvailable(event) {
      this.serviceWorkerRegistration = event.detail
      this.serviceWorkerHasUpdate = true

      this.addAlert({
        countdown: true,
        label:
          'An update is available, please force refresh the page to load it...',
        click: () => {
          this.refresh()
        }
      })
    }
  },

  created() {
    /* Listen for our custom event from the SW registration */
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    /* Prevent multiple refreshes */
    if (navigator && navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.serviceWorkerRefreshing) return
        this.serviceWorkerRefreshing = true
        window.location.reload()
      })
    }
  }
}
